/*
 * @Author: zhang lin
 * @Date:  2022-05-09 14:30:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-05-12 16:30:15
 */
import request from 'root/utils/request';

const basePath = '/api/ops-manager/v1/supos/alert';

// 获取告警阈值信息
export const getAlarm = async (params?: any) => {
  return request.get(`${basePath}/config`, { params: { ...params } });
};
// 设置阈值
export const setAlarmConfigApi = async (params?: any) => {
  return request.post(`${basePath}/config`, params);
};
// 改变状态
export const editStatus = async (params: any) => {
  return request.post(`${basePath}/config_status_edit`, params);
};
